import { api } from './api';
import type {
  CreateFeatureRequest,
  Feature,
  UpdateFeatureRequest,
} from '../types/feature';

class FeatureService {
  async getAll(productModuleId?: string): Promise<Feature[]> {
    const params = productModuleId ? { productModuleId } : undefined;
    const response = await api.get<Feature[]>('/features', { params });
    return response.data;
  }

  async getById(id: string): Promise<Feature> {
    const response = await api.get<Feature>(`/features/${id}`);
    return response.data;
  }

  async getByCode(code: string): Promise<Feature> {
    const response = await api.get<Feature>(`/features/code/${encodeURIComponent(code)}`);
    return response.data;
  }

  async create(payload: CreateFeatureRequest): Promise<Feature> {
    const response = await api.post<Feature>('/features', payload);
    return response.data;
  }

  async update(id: string, payload: UpdateFeatureRequest): Promise<Feature> {
    const response = await api.put<Feature>(`/features/${id}`, payload);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/features/${id}`);
  }
}

export const featureService = new FeatureService();
